import { actionGenerator } from "utils";

const PREFIX = "ADDRESS";

export const GET_PROVINCES = actionGenerator.genActionTypes(
  `${PREFIX}_GET_PROVINCES`
);

export const GET_DISTRICTS = actionGenerator.genActionTypes(
  `${PREFIX}_GET_DISTRICTS`
);

export const GET_COMMUNES = actionGenerator.genActionTypes(
  `${PREFIX}_GET_COMMUNES`
);

export const DELIVERY_INFO = actionGenerator.genActionTypes(
  `${PREFIX}_DELIVERY_INFO`
);
